import { filter, lowerCase, map } from 'lodash-es';
import { useMemo } from 'react';
import { useExportTemplateDefaultItem } from './use-export-template-default-item';

export function useDefaultConvertTemplateData() {
  const defaultItems = useExportTemplateDefaultItem();

  return useMemo(() => {
    return map(defaultItems.items, (category) => {
      const checkedEntries = filter(category.entries, 'checked');
      const bottomEntries = filter(category.entries, { isBottom: true });

      // Check if any bottom entries have selected fields
      const bottomEntriesWithSelectedFields = bottomEntries.filter(
        (bottomEntry) => bottomEntry.fields.some((field) => field.selected)
      );

      // Include both checked entries and bottom entries
      const entriesToInclude = [
        ...checkedEntries,
        ...bottomEntries.filter(
          (bottomEntry) =>
            !checkedEntries.some(
              (checkedEntry) => checkedEntry.name === bottomEntry.name
            )
        ),
      ];

      return {
        key: category.key,
        categoryName: lowerCase(category.name),
        disabled: category.disabled,
        isSingleEntry: category.isSingleEntry,
        entries: map(entriesToInclude, (entry, index) => ({
          index: entry.isBottom ? 1000000 : index,
          isBottom: entry.isBottom,
          notAdded:
            entry.isBottom && bottomEntriesWithSelectedFields.length === 0,
          fields: map(filter(entry.fields, 'selected'), (field) => field.type),
        })),
      };
    });
  }, [defaultItems]);
}
